// Translations
import form from '../sections/form/translations/ua'

// Translation: Verification > Landing (Ukrainian)
export default Object.freeze({
	sections: { form }
})
